import { cn as e } from "../cn.js";
import { getStyles as t } from "./style.js";
import { EmptyStatePresets as n } from "./presets.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
var a = Object.assign(({ title: n, description: a, icon: o, children: s, config: c, className: l }) => {
	let u = t(c);
	return /* @__PURE__ */ r("div", {
		className: e(u.root(), l),
		children: /* @__PURE__ */ i("div", {
			className: u.content(),
			children: [
				o && /* @__PURE__ */ r("div", {
					className: u.indicator(),
					children: o
				}),
				/* @__PURE__ */ i("div", {
					className: "space-y-2",
					children: [/* @__PURE__ */ r("h3", {
						className: u.title(),
						children: n
					}), a && /* @__PURE__ */ r("p", {
						className: u.description(),
						children: a
					})]
				}),
				s && /* @__PURE__ */ r("div", {
					className: u.actions(),
					children: s
				})
			]
		})
	});
}, {
	Root: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("div", {
			className: e(s.root(), i),
			...o,
			children: n
		});
	},
	Content: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("div", {
			className: e(s.content(), i),
			...o,
			children: n
		});
	},
	Indicator: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("div", {
			className: e(s.indicator(), i),
			...o,
			children: n
		});
	},
	Title: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("h3", {
			className: e(s.title(), i),
			...o,
			children: n
		});
	},
	Description: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("p", {
			className: e(s.description(), i),
			...o,
			children: n
		});
	},
	Actions: ({ children: n, className: i, config: a, ...o }) => {
		let s = t(a);
		return /* @__PURE__ */ r("div", {
			className: e(s.actions(), i),
			...o,
			children: n
		});
	},
	getStyles: t
});
export { a as EmptyState, n as EmptyStatePresets };

//# sourceMappingURL=index.js.map